import { useEffect, useState } from 'react';
import api, { errMsg } from '../lib/api';
import { useAuth } from '../lib/AuthContext';
import QuoteHero from '../components/ludo/dash/QuoteHero';
import PipelineCard from '../components/ludo/dash/PipelineCard';
import InquiryCard from '../components/ludo/dash/InquiryCard';
import ScheduleCard from '../components/ludo/dash/ScheduleCard';
import CredCard from '../components/ludo/dash/CredCard';
import TodayCard from '../components/ludo/dash/TodayCard';

export default function LudoDashboard() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => { api.get('/ludo/dashboard').then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, []);
  const canVault = ['super_user', 'admin', 'hr_payroll'].includes(user?.role);
  return (
    <div className="space-y-6" data-testid="ludo-dashboard-page">
      <style>{`@keyframes ludoRise{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}.ludo-rise{animation:ludoRise .5s ease-out both}`}</style>
      <QuoteHero />
      {err && <div className="text-[13px] text-[#8A3A3A]" data-testid="ludo-dashboard-error">{err}</div>}
      {!d && !err && <div className="text-[#6E5F78]" data-testid="ludo-dashboard-loading">Loading dashboard…</div>}
      {d && (
        <>
          <div className="ludo-rise" style={{ animationDelay: '60ms' }}><TodayCard t={d.today} /></div>
          <div className="grid xl:grid-cols-2 gap-6">
            <div className="ludo-rise" style={{ animationDelay: '120ms' }}><PipelineCard p={d.pipeline} /></div>
            <div className="ludo-rise" style={{ animationDelay: '180ms' }}><ScheduleCard s={d.schedule} /></div>
          </div>
          <div className="ludo-rise" style={{ animationDelay: '240ms' }}><InquiryCard q={d.inquiries} /></div>
          {canVault && d.credentialing && <div className="ludo-rise" style={{ animationDelay: '300ms' }}><CredCard c={d.credentialing} canOpen={canVault} /></div>}
        </>
      )}
    </div>
  );
}
